import React from "react";
import { Switch, Route } from "react-router-dom";
import Product from "./Index";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Detail";
export default () => (
  <Switch>
    <Route exact path="/product" component={Product} />
    <Route path="/product/create" component={Add} />
    <Route path="/product/edit/:id" component={Edit} />
    <Route path="/product/detail/:id" component={Detail} />
  </Switch>
);
